import React from 'react';

const Experience = () => {
  return (
    <section id="experience" aria-label="Experiencia">
      <h2 className="text-2xl font-poppins mb-4">Experiencia Profesional</h2>

      <article className="mb-6">
        <h3 className="font-semibold">Certicamara — Octubre 2024 - Abril 2025</h3>
        <ul className="list-disc pl-5">
          <li>Soluciones serverless en Python (AWS Lambda / Azure Functions).</li>
          <li>OCR con Azure Form Recognizer ({'>'}95% precisión) y migraciones React → Angular.</li>
          <li>Interfaces accesibles (WCAG 2.1 AA), generación Excel y SonarCloud.</li>
        </ul>
      </article>

      <article>
        <h3 className="font-semibold">YEDA — Abril 2025 - Presente</h3>
        <ul className="list-disc pl-5">
          <li>Desarrollo con Angular standalone y Firebase; autenticación rol-based.</li>
          <li>UX con Tailwind y Angular Material — reducción de abandono 35%.</li>
          <li>Automatizaciones PDF / CI/CD (GitHub Actions) y bots para Android.</li>
        </ul>
      </article>
    </section>
  );
};

export default Experience;
